{
    "UserNotificationBusyTime": "Ontvang een melding wanneer je team bezig is.",
    "UserNotificationMissedCalls": "Ontvang een melding als je binnen 60 minuten een bepaald aantal oproepen hebt gemist.",
    "UserNotificationWeeklyInsightsReport": "Ontvang een wekelijks prestatierapport.",
    "UserNotificationUserNotLoggedIn7Days": "Ontvang een melding wanneer je 7 dagen niet hebt ingelogd.",
    "UserNotificationAvgAnswerTime": "Ontvang een melding wanneer je gemiddelde antwoordtijd een bepaald aantal seconden overschrijdt met tussenpozen van een half uur.",
    "UserNotificationUserNeverLoggedIn": "Ontvang een melding wanneer je niet inlogt.",
    "NAME": "UserNotificationTypesHelp"
}